import { createContext } from 'react';

export const documentLang = (): string | undefined =>
  document.location.href.split('?lang=')[1]?.substring(0, 2);

export const LANG = documentLang() ?? 'en';
export const Context = createContext(LANG);
export const Provider = Context.Provider;
